import { Injectable } from '@angular/core';
import { Business } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class CIBC_SIMPLII_FINANCIAL_DOCUMENTS_SECURE_LINE_OF_CREDIT_FINAL_REPORT_Mapper extends BaseFormMapper<CIBC_SIMPLII_FINANCIAL_DOCUMENTS_SECURE_LINE_OF_CREDIT_FINAL_REPORT> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: CIBC_SIMPLII_FINANCIAL_DOCUMENTS_SECURE_LINE_OF_CREDIT_FINAL_REPORT,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as CIBC_SIMPLII_FINANCIAL_DOCUMENTS_SECURE_LINE_OF_CREDIT_FINAL_REPORT);

		return _formData;
	}

	MapValues(): Partial<CIBC_SIMPLII_FINANCIAL_DOCUMENTS_SECURE_LINE_OF_CREDIT_FINAL_REPORT> {
		return {};
	}
}

const Mappings: CIBC_SIMPLII_FINANCIAL_DOCUMENTS_SECURE_LINE_OF_CREDIT_FINAL_REPORT =
	{
		// "0":"ButtonSubmit0",
		signature: 'text23',
		solicitorName: 'text22',
		dateYear: 'text21',
		dateMonth: 'text20',
		dateDay: 'text19',
		datedAt: 'text18',
		enclosures: 'text15',
		fireInsuranceAgent: 'CC019',
		fireInsurancePolicyNumber: 'text13',
		fireInsuranceName: 'text14',
		taxesPaidTo: 'text11',
		mortgageAmount: 'text08',
		registrationDate: 'text10',
		registryOffice: 'text07',
		parcelIdentification: 'text09',
		mortgageDate: 'text06',
		registrationNumber: 'text05',
		electronicRegistration: 'CC010',
		legalDescription: 'text04',
		propertyAddress: 'text03',
		mortgagor: 'text02',
		referenceNumber: 'text01',
	};

export interface CIBC_SIMPLII_FINANCIAL_DOCUMENTS_SECURE_LINE_OF_CREDIT_FINAL_REPORT {
	referenceNumber: string;
	mortgagor: string;
	propertyAddress: string;
	legalDescription: string;

	electronicRegistration: string;
	registrationNumber: string;

	mortgageDate: string;
	parcelIdentification: string;

	registryOffice: string;
	registrationDate: string;

	mortgageAmount: string;
	taxesPaidTo: string;

	fireInsuranceName: string;
	fireInsurancePolicyNumber: string;
	fireInsuranceAgent: string;

	enclosures: string;

	datedAt: string;
	dateDay: string;
	dateMonth: string;
	dateYear: string;

	solicitorName: string;
	signature: string;
}
